import { message } from "antd";
import FetchData from '@ezviz/FetchData';
import moment from "moment";
import util from './../../utils/utils';
import intl from 'react-intl-universal';
import { getProductBaseInfo } from './product'

export const GET_RELEASE_STATUS = "GET_RELEASE_STATUS";


// 查看发布状态
export function getReleaseStatus(value, callback) {
  return (dispatch, getState) => {
    const { productDetail } = getState().product;
    const { productId, firmwareUpgradeCode } = productDetail
    const defaultParam = {
      pId: productId,
      firmwareUpgradeCode,
      publishStatus: value
    };

    const url = `/iot/config/api/iot/support/product/release?pId=${productId}&firmwareUpgradeCode=${firmwareUpgradeCode}&publishStatus=${value}`;
    const fetchData = new FetchData(url, {
      method: "POST",
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        if (res && res.code == 60016) {
          message.error(res.msg);
        } else if (res.code === '50004') {
          dispatch(getProductBaseInfo({
            pid: productId
          }))
          // dispatch({
          //     type: GET_RELEASE_STATUS,
          //     releaseMess:res.msg,
          //   });
          callback && callback()
        } else if (res.code === '200') {
          dispatch(getProductBaseInfo({
            pid: productId
          }))
          // dispatch({
          //   type: GET_RELEASE_STATUS,
          //   releaseMess:"成功_-5",
          // });
          callback && callback()
        }
      })
      .catch(e => {

      });
  };
}

// 查看发布状态
export function checkRelease(value, callback) {
  return (dispatch, getState) => {
    const { productDetail } = getState().product;
    const { productId, firmwareUpgradeCode } = productDetail
    const url = `/iot/config/api/iot/support/product/release/check?pId=${productId}`;
    const fetchData = new FetchData(url, {
      method: "POST",
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        if (res && res.code == 60016) {
          message.error(res.msg);
        } else if (res.code === '50004') {
          dispatch(getProductBaseInfo({
            pid: productId
          }))
          dispatch({
            type: GET_RELEASE_STATUS,
            releaseMess: res.data,
          });
          callback && callback()
        } else if (res.code === '200') {
          dispatch(getProductBaseInfo({
            pid: productId
          }))
          dispatch({
            type: GET_RELEASE_STATUS,
            releaseMess: "5",
          });
          callback && callback()
        }
      })
      .catch(e => {

      });
  };
}

// 撤销发布
export function cancelRelease(pid, callback) {
  return (dispatch, getState) => {
    const fetchData = new FetchData(`/iot/config/api/iot/support/product/unPublish?pid=${pid}`, {
      method: 'POST',
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData.then(res => {
      if (res.code == 200) {
        message.success(intl.get('commmon.operate.success'));
        callback && callback(res);
      } else {
        message.error(intl.get(`commmon.operate.retry`));
      }
    }).catch(e => {
      message.error(intl.get(`commmon.operate.retry`));
    });
  };
}
